export enum TRANSMISSION_TYPES {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
  CVT = 'CVT',
}
